export const TURNSTILE_SCRIPT_SRC =
  'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onTurnstileLoad&render=explicit'

const SCRIPT_SELECTOR = 'script[data-turnstile-script]'

let scriptLoadPromise: Promise<void> | null = null

function notifyTurnstileReady() {
  if (typeof window === 'undefined' || !window.turnstile) return
  window.dispatchEvent(new Event('turnstile-script-ready'))
}

function findExistingTurnstileScript(): HTMLScriptElement | null {
  return (
    document.querySelector<HTMLScriptElement>(SCRIPT_SELECTOR) ??
    document.querySelector<HTMLScriptElement>('script[src*="turnstile/v0/api.js"]')
  )
}

function ensureOnTurnstileLoadBridge() {
  window.onTurnstileLoad = () => {
    notifyTurnstileReady()
  }
}

export function loadTurnstileScript(): Promise<void> {
  if (typeof window === 'undefined') {
    return Promise.resolve()
  }

  if (window.turnstile) {
    return Promise.resolve()
  }

  if (scriptLoadPromise) {
    return scriptLoadPromise
  }

  scriptLoadPromise = new Promise<void>((resolve, reject) => {
    const onReady = () => {
      window.removeEventListener('turnstile-script-ready', onReady)
      if (window.turnstile) {
        resolve()
        return
      }
      reject(new Error('Turnstile script loaded but API is unavailable'))
    }

    window.addEventListener('turnstile-script-ready', onReady)

    const existingScript = findExistingTurnstileScript()
    if (existingScript) {
      if (window.turnstile) {
        window.removeEventListener('turnstile-script-ready', onReady)
        resolve()
      }
      return
    }

    ensureOnTurnstileLoadBridge()

    const script = document.createElement('script')
    script.src = TURNSTILE_SCRIPT_SRC
    script.async = true
    script.setAttribute('data-turnstile-script', 'true')
    script.onerror = () => {
      window.removeEventListener('turnstile-script-ready', onReady)
      scriptLoadPromise = null
      reject(new Error('Failed to load Turnstile script'))
    }
    document.head.appendChild(script)
  })

  return scriptLoadPromise
}
